import { Component, OnInit } from '@angular/core';
import {RealEstate} from '../../interfaces/real-estate';
import {RealEstateService} from '../../services/real-estate/real-estate.service';
import {RealEstateCardComponent} from '../real-estate-card/real-estate-card.component';
import { HomeHeroSectionComponent } from './home-hero-section.component';
import { HomeProofStripComponent } from './home-proof-strip.component';
import { HomeHowItWorksSectionComponent } from './home-how-it-works-section.component';
import { HomeAnalysisSectionComponent } from './home-analysis-section.component';
import { HomeAlertsSectionComponent } from './home-alerts-section.component';
import { HomeFinalCtaSectionComponent } from './home-final-cta-section.component';

@Component({
  selector: 'app-home',
  imports: [
    RealEstateCardComponent,
    HomeHeroSectionComponent,
    HomeProofStripComponent,
    HomeHowItWorksSectionComponent,
    HomeAnalysisSectionComponent,
    HomeAlertsSectionComponent,
    HomeFinalCtaSectionComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  realEstates: RealEstate[] = [];

  constructor(
    private realEstateService: RealEstateService
  ) {}

  ngOnInit(): void {
    this.realEstateService.getExampleRealEstates().subscribe(
      (data) => {
        this.realEstates = data;
      }
    );
  }
}
